import { IconID } from '@thoughtspot/radiant-react/widgets/icon';
import { SpotlightItemType } from '../spotlight.types';
export const getDataNavItems = (t) => [
    {
        id: 'data-home',
        label: t('newNavigation.data'),
        labelKey: 'newNavigation.data',
        description: t('spotlight.nav.data.description'),
        icon: IconID.TABLE,
        type: SpotlightItemType.NAVIGATION,
        path: '/data',
        keywords: ['data', 'workspace', 'sources', 'database'],
    },
    {
        id: 'data-tables',
        label: t('metadataListPage.dataManagement.tables.tabHeader'),
        labelKey: 'metadataListPage.dataManagement.tables.tabHeader',
        description: t('spotlight.nav.tables.description'),
        icon: IconID.TABLE,
        type: SpotlightItemType.NAVIGATION,
        path: '/data/tables',
        keywords: [
            'tables',
            'data',
            'objects',
            'database',
            'data workspace',
            'data objects',
        ],
    },
    {
        id: 'data-connections',
        label: t('spotlight.nav.connections'),
        labelKey: 'spotlight.nav.connections',
        description: t('spotlight.nav.connectionsDesc'),
        icon: IconID.CONNECTOR_WHITE,
        type: SpotlightItemType.NAVIGATION,
        path: '/data/embrace',
        keywords: ['connections', 'embrace', 'database', 'sources'],
    },
    {
        id: 'data-spotapps',
        label: t('metadataListPage.dataManagement.spotApp.tabHeader'),
        labelKey: 'metadataListPage.dataManagement.spotApp.tabHeader',
        description: t('spotlight.nav.spotApps.description'),
        icon: IconID.SPOTTER_TOOLS,
        type: SpotlightItemType.NAVIGATION,
        path: '/data/spotapp',
        keywords: ['spotapps', 'apps', 'templates'],
    },
    {
        id: 'data-datasets',
        label: t('dataworkspace.datasets.pageTitle'),
        labelKey: 'dataworkspace.datasets.pageTitle',
        description: t('spotlight.nav.datasets.description'),
        icon: IconID.TABLE,
        type: SpotlightItemType.NAVIGATION,
        path: '/data/dataset',
        keywords: ['datasets', 'data'],
    },
    {
        id: 'data-dataflow',
        label: t('spotlight.nav.dataflow'),
        labelKey: 'spotlight.nav.dataflow',
        description: t('spotlight.nav.dataflowDesc'),
        icon: IconID.TABLE,
        type: SpotlightItemType.NAVIGATION,
        path: '/data/dataflow',
        keywords: ['dataflow', 'etl', 'pipeline'],
    },
    {
        id: 'data-sql-view',
        label: t('SQL_VIEW'),
        labelKey: 'SQL_VIEW',
        description: t('spotlight.nav.sqlView.description'),
        icon: IconID.CODE,
        type: SpotlightItemType.NAVIGATION,
        path: '/data/sql-view',
        keywords: ['sql', 'view', 'query'],
    },
    {
        id: 'data-dbt',
        label: t('datamodel.navpanel.dbt.label'),
        labelKey: 'datamodel.navpanel.dbt.label',
        description: t('spotlight.nav.dbt.description'),
        icon: IconID.CODE,
        type: SpotlightItemType.NAVIGATION,
        path: '/data/dbt',
        keywords: ['dbt', 'integration', 'transform'],
    },
    {
        id: 'data-custom-calendar',
        label: t('spotlight.nav.customCalendar'),
        labelKey: 'spotlight.nav.customCalendar',
        description: t('spotlight.nav.customCalendarDesc'),
        icon: IconID.CALENDAR,
        type: SpotlightItemType.NAVIGATION,
        path: '/data/custom-calendar',
        keywords: ['calendar', 'custom', 'fiscal'],
    },
    {
        id: 'data-app-connections',
        label: t('spotlight.nav.appConnections'),
        labelKey: 'spotlight.nav.appConnections',
        description: t('spotlight.nav.appConnectionsDesc'),
        icon: IconID.CONNECTOR_WHITE,
        type: SpotlightItemType.NAVIGATION,
        path: '/data/app-connections',
        keywords: ['connections', 'apps', 'integrations'],
    },
    {
        id: 'data-memory',
        label: t('spotlight.nav.aiMemory'),
        labelKey: 'spotlight.nav.aiMemory',
        description: t('spotlight.nav.aiMemoryDesc'),
        icon: IconID.CHART_SPOTIQ_ANOMALY_LESS,
        type: SpotlightItemType.NAVIGATION,
        path: '/data/memory',
        keywords: ['memory', 'ai', 'feedback', 'query'],
    },
    {
        id: 'data-governance',
        label: t('spotlight.nav.dataGovernance'),
        labelKey: 'spotlight.nav.dataGovernance',
        description: t('spotlight.nav.dataGovernanceDesc'),
        icon: IconID.AXIS_SETTINGS,
        type: SpotlightItemType.NAVIGATION,
        path: '/data/data-governance',
        keywords: ['governance', 'policy', 'compliance', 'catalog'],
    },
    {
        id: 'data-liveboard-verification',
        label: t('spotlight.nav.liveboardVerification'),
        labelKey: 'spotlight.nav.liveboardVerification',
        description: t('spotlight.nav.liveboardVerificationDesc'),
        icon: IconID.LIVEBOARD_V2,
        type: SpotlightItemType.NAVIGATION,
        path: '/data/liveboard-verification',
        keywords: ['verification', 'liveboard', 'validate'],
    },
    {
        id: 'data-utilities',
        label: t('datamodel.navpanel.utilities.label'),
        labelKey: 'datamodel.navpanel.utilities.label',
        description: t('spotlight.nav.utilities.description'),
        icon: IconID.AXIS_SETTINGS,
        type: SpotlightItemType.NAVIGATION,
        path: '/data/utilities',
        keywords: ['utilities', 'tools', 'data'],
    },
    {
        id: 'data-destination-sync',
        label: t('spotlight.nav.destinationSync'),
        labelKey: 'spotlight.nav.destinationSync',
        description: t('spotlight.nav.destinationSyncDesc'),
        icon: IconID.TABLE,
        type: SpotlightItemType.NAVIGATION,
        path: '/data/destination-sync',
        keywords: ['destination', 'sync', 'export'],
    },
    {
        id: 'data-usage-statistics',
        label: t('spotlight.nav.usageStatistics'),
        labelKey: 'spotlight.nav.usageStatistics',
        description: t('spotlight.nav.usageStatisticsDesc'),
        icon: IconID.CHART_SPOTIQ_ANOMALY_LESS,
        type: SpotlightItemType.NAVIGATION,
        path: '/data/usage-statistics',
        keywords: ['usage', 'statistics', 'stats', 'activity', 'admin'],
    },
    {
        id: 'data-usage',
        label: t('spotlight.nav.dataUsage'),
        labelKey: 'spotlight.nav.dataUsage',
        description: t('spotlight.nav.dataUsageDesc'),
        icon: IconID.CHART_SPOTIQ_ANOMALY_LESS,
        type: SpotlightItemType.NAVIGATION,
        path: '/teams/data-usage',
        keywords: ['usage', 'data', 'consumption', 'teams'],
    },
    {
        id: 'data-spotapps-admin',
        label: t('spotlight.nav.spotAppsAdmin'),
        labelKey: 'spotlight.nav.spotAppsAdmin',
        description: t('spotlight.nav.spotAppsAdminDesc'),
        icon: IconID.SPOTTER_TOOLS,
        type: SpotlightItemType.NAVIGATION,
        path: '/data/spotapps-admin',
        keywords: ['spotapps', 'admin', 'manage', 'apps'],
    },
    {
        id: 'data-semantic-integrations',
        label: t('spotlight.nav.semanticIntegrations'),
        labelKey: 'spotlight.nav.semanticIntegrations',
        description: t('spotlight.nav.semanticIntegrationsDesc'),
        icon: IconID.CONNECTOR_WHITE,
        type: SpotlightItemType.NAVIGATION,
        path: '/data/semantic-integrations',
        keywords: ['semantic', 'integrations', 'model', 'connect'],
    },
];
export const DATA_NAV_ITEMS = getDataNavItems((key) => key);
//# sourceMappingURL=data.js.map